import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getUserTypes(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: value
        description: name
      }
      recordCount
    }
  }
`;

export function useGetUserTypesAsOptionsQuery() {
  return useLazyQuery(gqlGetValues);
  //return [null, { loading: null, data: null }];
}

export const FieldSelectUserType = ({
  label = 'Τύπος Χρήστη',
  name = 'usertypeId',
  defaultValues = {},
  ...rest
}: FsProps) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      // @ts-ignore
      //sbLabel={defaultValues?.batteriescollectionsState?.name ?? undefined}
      hook={useGetUserTypesAsOptionsQuery}
    />
  );
};

